import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRemix: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRemix"><Path d="M3.5 14V4.5H20" stroke="currentColor"/><Path d="M17.5 1.5L20.5 4.5L17.5 7.5" stroke="currentColor"/><Path d="M6.5 22.5L3.5 19.5L6.5 16.5" stroke="currentColor"/><Path d="M4 19.5H20.5V10" stroke="currentColor"/><Path d="M12 8V16" stroke="currentColor"/><Path d="M8 12H16" stroke="currentColor"/></CentralIconBase>;
});

export default IconRemix;
